import PrimaryButtonSmall from "../designSystem/buttons/PrimaryButtonSmall";
import SecondaryButtonSmall from "../designSystem/buttons/SecondaryButtonSmall";
import SEO from "../designSystem/SEO";
import Home1 from "../../assets/images/home_banner.png";
import Home2 from "../../assets/images/home_mortgageadvice.png";
import { ReactComponent as ResidentialIcon } from "../../assets/icons/residential_mortgages.svg";
import { ReactComponent as RemortgagingIcon } from "../../assets/icons/remortgaging.svg";
import { ReactComponent as BuyToLetIcon } from "../../assets/icons/buy_to_let_mortgages.svg";
import { ReactComponent as SpecialistIcon } from "../../assets/icons/specialist_mortgages.svg";
import { ReactComponent as ProtectionIcon } from "../../assets/icons/protection.svg";
import { ReactComponent as PersonalIcon } from "../../assets/icons/personal.svg";
import { ReactComponent as ProfessionalIcon } from "../../assets/icons/professional.svg";
import { ReactComponent as ResponsiveIcon } from "../../assets/icons/responsive.svg";
import { ReactComponent as HonestIcon } from "../../assets/icons/honest.svg";

const services = [
  {
    title: "Residential Mortgages",
    icon: ResidentialIcon,
    description:
      "Buying your first home, moving home or purchasing your forever property? We'll help you secure the right mortgage with expert guidance every step of the way.",
  },
  {
    title: "Remortgaging",
    icon: RemortgagingIcon,
    description:
      "Whether you're coming to the end of your current deal or looking to release equity, we'll help you review your options and potentially save money.",
  },
  {
    title: "Buy to Let Mortgages",
    icon: BuyToLetIcon,
    description:
      "From first-time landlords to experienced property investors, we provide specialist advice to help you grow and manage your property portfolio.",
    note: "The Financial Conduct Authority does not regulate most buy to let mortgages.",
  },
  {
    title: "Specialist Mortgages",
    icon: SpecialistIcon,
    description:
      "Self-employed? Complex income? Large loans or unusual circumstances? We have access to lenders who understand that not every application fits standard criteria.",
  },
  {
    title: "Protection",
    icon: ProtectionIcon,
    description:
      "A mortgage protects your home. Protection insurance helps protect everything else. We'll help you safeguard your income, family and financial future with tailored insurance solutions.",
  },
];

const reasonsToChooseTag = [
  {
    label: "Adviser",
    title: "Personal Advice",
    icon: PersonalIcon,
    description:
      "You'll work with a dedicated adviser who understands your goals and keeps things simple from start to finish.",
  },
  {
    label: "Market",
    title: "Wide Choice of Lenders",
    icon: ProfessionalIcon,
    description:
      "Access to a broad range of high street banks, building societies and specialist lenders.",
  },
  {
    label: "Process",
    title: "Straightforward Process",
    icon: ResponsiveIcon,
    description:
      "We take care of the paperwork, communicate with everyone involved and keep you updated throughout.",
  },
  {
    label: "Beyond",
    title: "Support Beyond Completion",
    icon: HonestIcon,
    description:
      "Our relationship doesn't end when your mortgage completes. We're here whenever your circumstances change or your deal needs reviewing.",
  },
];

const ServiceIcon = ({ icon: Icon }) => {
  return (
    <span
      className="row-center bg-gray-3 p-s all-radius-xl text-primary-2"
      aria-hidden="true"
    >
      <Icon />
    </span>
  );
};

const LandingPage = () => {
  return (
    <div>
      <SEO
        title="Mortgage & Protection Advice"
        description="Clear, personal mortgage and protection advice from TAG Mortgages for home buyers, remortgages, property investors and specialist borrowers across the UK."
        path="/"
      />
      {/* <Hero
        title={`Financial Clarity
Direction & Confidence`}
        subtitle="Wealth Management Solutions"
        titleAlign="left"
        subtitleAlign="left"
      >
        <div className="hero-column">
          <div className="content">
            At FG Wealth Advisory, we provide clear, personalised financial
            advice to help you grow, protect and maximise your wealth. By
            understanding your goals, we deliver tailored support across
            pensions, investments and insurance for individuals, families and
            business owners, with a focus on long-term relationships that bring
            confidence, clarity and control over your financial future.
          </div>

        
        </div>
      </Hero>
      <div className="page-container">
        <PrimaryButton text="Primary Button" />
        <PrimaryButtonSmall text="Primary Button Small" />
        <SecondaryButton text="Secondary Button" />
        <SecondaryButtonSmall text="Secondary Button Small" />
        <TextButton text="Text Button" />
        <SeeMoreButton text="See More" />
        <TertiaryButton text="Tertiary Button" />
        <Accordion
          title="Accordion Title"
          children={
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
          }
        />
      </div> */}
      <div className="background-container bg-white">
        <div className="content-container row-center grid2 gap-xxxxl row-center">
          <div className="column gap-l">
            <div className="body-2  text-primary-2 uppercase">
              - MORTGAGE ADVICE
            </div>
            <h1 className="text-primary-1">
              Mortgages Made Simple. Advice You Can{" "}
              <span className="h1-italic text-primary-2">Trust</span>.
            </h1>
            <div className="column gap-m">
              <div className="content text-gray-1">
                Finding the right mortgage shouldn't be complicated. At TAG
                Mortgages, we provide clear, straightforward advice tailored to
                your circumstances, helping you make confident decisions at
                every stage of your property journey.
              </div>
              <div className="content text-gray-1">
                Whether you're buying your first home, moving house,
                remortgaging, investing in property or looking for specialist
                finance, our experienced advisers are here to guide you from
                application through to completion.
              </div>
              <div className="content text-gray-1">
                With access to an extensive panel of UK lenders, we search the
                market to find mortgage solutions that work for you.
              </div>
            </div>
            <div className="row-flex-start gap-l">
              <PrimaryButtonSmall text="speak to an adviser" />
              <SecondaryButtonSmall text="explore our services" />
            </div>
          </div>{" "}
          <img
            src={Home1}
            alt="TAG Mortgages adviser discussing mortgage options with clients"
            className="hero-image"
          />
        </div>
      </div>

      <div className="background-container">
        <div className="content-container row-center grid2 gap-xxxxl">
          <img
            src={Home2}
            alt="Mortgage adviser reviewing a client's mortgage needs"
            className="hero-image"
          />
          <div className="column gap-l">
            <div className="body-2  text-primary-2 uppercase">
              - ADVICE BUILT AROUND YOU
            </div>
            <h2 className="h4 text-primary-1">
              Mortgage Advice That Puts You First
            </h2>
            <div className="column gap-m">
              <div className="content text-gray-1">
                Every client has different goals, which is why we never believe
                in one-size-fits-all advice. We take the time to understand your
                circumstances before recommending the most suitable mortgage and
                protection options.
              </div>
              <div className="content text-gray-1">
                From your first enquiry to receiving your keys, we'll handle the
                paperwork, liaise with lenders, estate agents and solicitors,
                and keep everything moving smoothly.
              </div>
            </div>
            <div className="body1 text-gray-1">
              Your home may be repossessed if you do not keep up repayments on
              your mortgage.
            </div>
          </div>
        </div>
      </div>
      <section id="services" className="background-container bg-gray-3">
        <div className="content-container ">
          <div className="column gap-l">
            <div className="body-2 text-primary-2 uppercase">- What We Do</div>
            <h2 className="h4 text-primary-1">Our Services</h2>
            <div className="grid-services gap-l">
              {services.map((service) => (
                <article
                  className="column gap-l bg-white p-l all-radius-m"
                  key={service.title}
                >
                  <ServiceIcon icon={service.icon} />
                  <div className="subtitle-semibold text-primary-1">
                    {service.title}
                  </div>
                  <div className="content text-gray-1">
                    {service.description}
                  </div>
                  {service.note && (
                    <div className="body1 text-gray-1">{service.note}</div>
                  )}
                </article>
              ))}
            </div>
          </div>
        </div>
      </section>
      <section className="background-container bg-white">
        <div className="content-container ">
          <div className="column gap-l">
            <div className="body2 text-primary-2 uppercase">
              - WHY TAG MORTGAGES
            </div>
            <h2 className="h4 text-primary-1">Why Choose TAG Mortgages?</h2>
            <div className="content text-gray-1">
              You'll work with a dedicated adviser who understands your goals
              and keeps things simple from start to finish.
            </div>
            <div className="grid4 gap-m">
              {reasonsToChooseTag.map((reason) => (
                <article className="column gap-s p-s" key={reason.title}>
                  {/* <ServiceIcon icon={reason.icon} /> */}
                  <div className="body2 text-primary-2 uppercase">
                    {reason.label}
                  </div>
                  <div className="subtitle-semibold text-primary-1">
                    {reason.title}
                  </div>
                  <div className="content text-gray-1">
                    {reason.description}
                  </div>
                </article>
              ))}
            </div>
          </div>
        </div>
      </section>
      <div className="background-container bg-primary-1">
        <div className="content-container">
          <div className="column gap-l align-center">
            <div className="body2  text-white uppercase">
              - LET’S GET YOU MOVING
            </div>

            <h2 className="h4 text-white">
              Whether you're taking your first step onto the property ladder or
              expanding your investment portfolio, TAG Mortgages is here to
              help.
            </h2>
            <div className="content text-white">
              Get in touch today and discover how simple arranging your mortgage
              can be.
            </div>
            <div className="body1 text-white">
              Your home may be repossessed if you do not keep up repayments on
              your mortgage.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
